var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("v-tabs", [_c("v-tab", [_vm._v("Log de Eventos ")])], 1),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs2: "", sm2: "", md2: "" } },
            [
              _c("DatePicker", {
                attrs: { label: _vm.formFields.dateStart.label },
                model: {
                  value: _vm.formFields.dateStart.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.dateStart, "value", $$v)
                  },
                  expression: "formFields.dateStart.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs2: "", sm2: "", md2: "" } },
            [
              _c("TimePicker", {
                attrs: { label: _vm.formFields.timeStart.label },
                model: {
                  value: _vm.formFields.timeStart.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.timeStart, "value", $$v)
                  },
                  expression: "formFields.timeStart.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs2: "", sm2: "", md2: "" } },
            [
              _c("DatePicker", {
                attrs: { label: _vm.formFields.dateEnd.label },
                model: {
                  value: _vm.formFields.dateEnd.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.dateEnd, "value", $$v)
                  },
                  expression: "formFields.dateEnd.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs2: "", sm2: "", md2: "" } },
            [
              _c("TimePicker", {
                attrs: { label: _vm.formFields.timeEnd.label },
                model: {
                  value: _vm.formFields.timeEnd.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.timeEnd, "value", $$v)
                  },
                  expression: "formFields.timeEnd.value"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs8: "", sm8: "", md8: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c("v-flex", { attrs: { xs2: "", sm2: "", md2: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.showTable } },
                          [
                            _c("v-icon", [_vm._v("search")]),
                            _vm._v("Filtrar ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-flex", { attrs: { xs2: "", sm2: "", md2: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.clearFilters } },
                          [
                            _c("v-icon", [_vm._v("clear")]),
                            _vm._v("Limpiar\n            ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      !_vm.showTables
        ? _c("div", { staticStyle: { "text-align": "center" } }, [
            _c("div", { attrs: { id: "textEmpty" } }, [
              _vm._v("No ha seleccionado ningún cliente")
            ]),
            _c("img", { attrs: { src: require("@/assets/emptyIcon.png") } })
          ])
        : _vm._e(),
      _c("v-divider"),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTables,
              expression: "showTables"
            }
          ],
          staticClass: "gridcard rounded-card proveedores"
        },
        [
          _c("ag-grid-vue", {
            staticClass: "ag-theme-material",
            staticStyle: {
              width: "100%",
              height: "auto",
              "font-family": "'Asap' sans-serif"
            },
            attrs: {
              gridOptions: _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }